import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'

const STORAGE_KEY = 'glory_selection'

function loadFromSession() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function saveToSession(group, store, terminal) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      selectedGroup:    group,
      selectedStore:    store,
      selectedTerminal: terminal,
    }))
  } catch { /* ignore */ }
}

export const useSelectionStore = defineStore('selection', () => {
  const saved = loadFromSession()

  const selectedGroup    = ref(saved.selectedGroup    ?? null)
  const selectedStore    = ref(saved.selectedStore    ?? null)
  const selectedTerminal = ref(saved.selectedTerminal ?? null)

  const hasSelection = computed(() => selectedTerminal.value !== null)

  // Persiste automaticamente no sessionStorage a cada mudança
  watch(
    [selectedGroup, selectedStore, selectedTerminal],
    ([g, s, t]) => saveToSession(g, s, t),
    { deep: true },
  )

  function selectGroup(group) {
    selectedGroup.value    = group
    selectedStore.value    = null
    selectedTerminal.value = null
  }

  function selectStore(store) {
    selectedStore.value    = store
    selectedTerminal.value = null
  }

  function selectTerminal(terminal) {
    selectedTerminal.value = terminal
  }

  function clearSelection() {
    selectedGroup.value    = null
    selectedStore.value    = null
    selectedTerminal.value = null
    sessionStorage.removeItem(STORAGE_KEY)
  }

  function backToGroups() {
    selectedGroup.value    = null
    selectedStore.value    = null
    selectedTerminal.value = null
  }

  function backToStores() {
    selectedStore.value    = null
    selectedTerminal.value = null
  }

  return {
    selectedGroup,
    selectedStore,
    selectedTerminal,
    hasSelection,
    selectGroup,
    selectStore,
    selectTerminal,
    clearSelection,
    backToGroups,
    backToStores,
  }
})
